import React from 'react';

// @ts-ignore
import covidBoxImage from './COVID-DTC-Box-Image.png';

import { Feature, Flagged, Stable } from 'components/Flagged';
// local imports
import * as S from './styles';
import { useFlags } from 'gatsby-plugin-launchdarkly';
import { Flags } from 'utils/constants/featureFlags';

export type DisclaimerProps = {
  handleDisclaimerClick: Function;
};

export const Disclaimer = ({ handleDisclaimerClick }: DisclaimerProps) => {
  const flags = useFlags();
  const covidQuestionaireFlag = flags[Flags.CovidQtyAndScreener];

  return (
    <S.DisclaimerTextWrapper>
      <S.HeadlineImage>
        <img src={covidBoxImage} alt="COVID-19 Test Home Collection Kit DTC" />
      </S.HeadlineImage>
      <Flagged flag={covidQuestionaireFlag}>
        <Feature>
          <S.Headline>
            Important Information about the COVID-19 Test Home Collection Kit DTC
          </S.Headline>
        </Feature>
        <Stable>
          <S.Headline>
            Welcome to your COVID-19 Test Home Collection Kit Eligibility
            Screener
          </S.Headline>
        </Stable>
      </Flagged>

      <S.TextContainer>
        <Flagged flag={covidQuestionaireFlag}>
          <Stable>
            <S.P>
              Test collection kit eligibility is determined based on a screening
              questionnaire at point of sale and/or collection kit registration.
              The test taker must be 18+.
            </S.P>
          </Stable>
          <Feature>
            <S.P>
              This kit should not be used by persons experiencing severe
              symptoms. Test kit eligibility will be determined on a screening
              questionnaire at kit registration. The kit test taker must be 18+.
            </S.P>
          </Feature>
        </Flagged>

        <S.P>
          COVID-19 is caused by the SARS-CoV-2 virus. Infection with the virus
          can range from being asymptomatic to life-threatening respiratory
          illness. Infection has been detected globally and in all 50 states.
          Symptoms associated with COVID-19 include cough, shortness of breath
          or difficulty breathing, fever, chills, muscle pain, headache, sore
          throat or new loss of taste or smell. .
        </S.P>
        <S.P>
          COVID-19 can present with severe illness in individuals of any age and
          without any previous health problems, but the risk for severe illness
          from COVID-19 increases with age, with older adults at highest risk.
          Having underlying medical conditions may also increase one’s risk for
          severe illness from COVID-19. Conditions and other risk factors that
          may be associated with severe illness and death are listed below.
        </S.P>

        <S.ListHeading>
          If you exhibit any symptoms of COVID-19 and have any of the following
          conditions or risk factors, you should consult with your healthcare
          provider before using this test as you may be at increased risk of
          severe illness from COVID-19:
        </S.ListHeading>
        <S.UL>
          <S.LI>Chronic kidney disease</S.LI>
          <S.LI>COPD (chronic obstructive pulmonary disease)</S.LI>
          <S.LI>
            Immunocompromised state (weakened immune system) from solid organ
            transplant or bone marrow transplant, immune deficiencies, HIV, use
            of corticosteroids, or use of other immune weakening medicines
          </S.LI>
          <S.LI>Obesity (body mass index [BMI] of 30 or higher)</S.LI>
          <S.LI>
            Serious heart conditions, such as heart failure, coronary artery
            disease, or cardiomyopathies
          </S.LI>
          <S.LI>Sickle cell disease</S.LI>
          <S.LI>Type 2 diabetes mellitus</S.LI>
          <S.LI>Asthma (moderate-to-severe)</S.LI>
          <S.LI>
            Cerebrovascular disease (affects blood vessels and blood supply to
            the brain)
          </S.LI>
          <S.LI>Cystic fibrosis</S.LI>
          <S.LI>Neurologic conditions, such as dementia</S.LI>
          <S.LI>Liver disease</S.LI>
          <S.LI>Pregnancy</S.LI>
          <S.LI>
            Pulmonary fibrosis (having damaged or scarred lung tissues)
          </S.LI>
          <S.LI>Smoking</S.LI>
          <S.LI>Thalassemia (a type of blood disorder)</S.LI>
          <S.LI>Type 1 diabetes mellitus</S.LI>
        </S.UL>
        <S.ListHeading>
          Regardless of your risk status, if you are experiencing any of the
          following emergency warning signs for COVID-19, it is recommended that
          you immediately seek emergency care:
        </S.ListHeading>
        <S.UL>
          <S.LI>Trouble breathing</S.LI>
          <S.LI>Persistent pain or pressure in the chest</S.LI>
          <S.LI>New confusion</S.LI>
          <S.LI>Inability to wake up or stay awake</S.LI>
          <S.LI>Bluish lips or face</S.LI>
        </S.UL>
        <S.P>
          This home collection kit has not been FDA cleared or approved.
        </S.P>
        <S.P>
          This home collection kit has been authorized by the FDA under an EUA.
        </S.P>
        <S.P>
          This home collection kit has been authorized only for the home
          collection and maintenance of nasal swab specimens as an aid in
          detection of nucleic acid from SARS-CoV-2, not for any other viruses
          or pathogens.
        </S.P>
        <S.P>
          This home collection kit, in combination with the authorized test, is
          only authorized for the duration of the declaration that circumstances
          exist justifying the authorization of emergency use of in vitro
          diagnostic tests for detection and/or diagnosis of COVID-19 under
          Section 564(b)(1) of the Act, 21 U.S.C. § 360bbb-3(b)(1), unless the
          authorization is terminated or revoked sooner.
        </S.P>
        <Flagged flag={covidQuestionaireFlag}>
          <Feature>
            <S.GetStartedButton
              appearance="hero"
              onClick={handleDisclaimerClick}
            >
              Order
            </S.GetStartedButton>
          </Feature>
          <Stable>
            <S.GetStartedButton
              appearance="primary"
              onClick={handleDisclaimerClick}
            >
              Get Started
            </S.GetStartedButton>
          </Stable>
        </Flagged>
      </S.TextContainer>
    </S.DisclaimerTextWrapper>
  );
};

export default Disclaimer;
